import { Mobile } from './Mobile'
import { Desktop } from './Desktop'

export const ResponsiveDesign = {
  Mobile,
  Desktop,
}
